/** Treat Yes / true / non-empty checkbox groups as "checked". */
const isTruthyAnswer = (value) => {
  if (value === true || value === 'Yes' || value === 'yes') return true;
  if (Array.isArray(value) && value.length > 0) return true;
  return false;
};

/** Evaluate field.visibleWhen against sibling values in the same group. */
export const isFieldVisible = (field, values = {}) => {
  const rules = field?.visibleWhen;
  if (!rules) return true;
  const list = Array.isArray(rules) ? rules : [rules];
  return list.every((rule) => {
    if (!rule || !rule.field) return true;
    const current = values?.[rule.field];
    if (Object.prototype.hasOwnProperty.call(rule, 'equals')) {
      // Checkbox gate: equals true also matches Yes / checked multi
      if (rule.equals === true || rule.equals === 'Yes') {
        return isTruthyAnswer(current) || current === rule.equals;
      }
      return current === rule.equals;
    }
    if (Array.isArray(rule.in)) {
      if (rule.in.includes(current)) return true;
      if (rule.in.includes(true) || rule.in.includes('Yes')) {
        return isTruthyAnswer(current);
      }
      return false;
    }
    return true;
  });
};

export const filterVisibleFields = (fields = [], values = {}) =>
  fields.filter((field) => isFieldVisible(field, values));

export const emptyForField = (field) => {
  if (field?.type === 'checkboxGroup' || field?.type === 'multi') {
    return [];
  }
  if (field?.type === 'checkbox' || field?.type === 'boolean') {
    return false;
  }
  if (
    field?.type === 'richNotes' ||
    field?.type === 'notes' ||
    field?.type === 'richtext'
  ) {
    return {
      format: 'tiptap',
      doc: { type: 'doc', content: [{ type: 'paragraph' }] },
    };
  }
  return '';
};

const valuesEqual = (a, b) => {
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((item, i) => item === b[i]);
  }
  return a === b;
};

/** When a parent changes, clear children that become hidden. */
export const getHiddenFieldClears = (fields = [], values = {}, nextValues = {}) => {
  const clears = [];
  fields.forEach((field) => {
    if (isFieldVisible(field, nextValues)) return;
    const empty = emptyForField(field);
    const current = values?.[field.id];
    if (current === undefined || valuesEqual(current, empty)) return;
    clears.push({ fieldId: field.id, value: empty });
  });
  return clears;
};
